import React, { useEffect, useRef, useState } from 'react';
import { Alert, Button, Stack, Typography } from '@mui/material';
import api from '../../../api/api';
import { useUserStore } from '../../../stores/userStore';

function CandidateListSession({ disabled, onSelect }) {
  const [page, setPage] = useState(0);
  const [result, setResult] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const alive = useRef(true);
  const pending = useRef(false);
  useEffect(() => {
    alive.current = true;
    return () => {
      alive.current = false;
    };
  }, []);
  async function load(nextPage) {
    if (pending.current || disabled) return;
    pending.current = true;
    setBusy(true);
    setError('');
    try {
      const response = await api.getAuth('/admin/direct-catalog/canonical-candidates', {
        params: { page: nextPage },
      });
      if (!alive.current) return;
      setPage(nextPage);
      setResult(response.data.data);
    } catch (e) {
      if (alive.current) setError(e.message || '후보 조회 실패');
    } finally {
      if (alive.current) {
        pending.current = false;
        setBusy(false);
      }
    }
  }
  return (
    <Stack spacing={1} sx={{ minWidth: 0, overflowWrap: 'anywhere' }}>
      <Button disabled={disabled || busy} onClick={() => load(0)}>
        현재 수집 DB에서 중복 후보 찾기
      </Button>
      <Typography variant="caption">
        수동 앨범을 20개씩 검사합니다. 새로 수집된 공식 앨범도 조회 시 반영됩니다. 제목·아티스트
        일치 후보이며 동일 판본 확정은 아닙니다. 후보가 없거나 다른 표기라면 아래 개별 검색을
        이용해주세요.
      </Typography>
      {error && <Alert severity="error">{error}</Alert>}
      {busy && <Typography role="status">조회 중…</Typography>}
      {result && (
        <Typography role="status">
          {page + 1}구간 · 후보 {result.items.length}개
        </Typography>
      )}
      {result?.items?.map(({ manual, official }) => (
        <Button
          key={`${manual.albumId}-${official.albumId}`}
          disabled={disabled || busy}
          onClick={() => onSelect(manual, official)}
        >
          {manual.title} · {manual.artistName} (수동 #{manual.albumId} → 공식 #{official.albumId})
        </Button>
      ))}
      {result?.items?.length === 0 && <Typography>이 구간에는 일치 후보가 없습니다.</Typography>}
      {result && (
        <Stack direction="row" sx={{ flexWrap: 'wrap' }}>
          <Button disabled={disabled || busy || page === 0} onClick={() => load(page - 1)}>
            이전 구간
          </Button>
          <Button disabled={disabled || busy || !result.hasMore} onClick={() => load(page + 1)}>
            다음 구간
          </Button>
        </Stack>
      )}
    </Stack>
  );
}

export default function CanonicalCandidateList(props) {
  const user = useUserStore((state) => state.user);
  return <CandidateListSession key={JSON.stringify([user?.id, user?.role])} {...props} />;
}
